export default "__VITE_ASSET__DKaWnG9b__"